import React, { useState } from "react";

import {
  ListUserInspectionsResponse,
  ListUserTemplatesResponse,
  Pagination,
} from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/support_pb";

import {
  UserInspectionListContext,
  UserInspectionsList,
  UserTemplateListContext,
  UserTemplatesList,
} from "./user-templates-and-inspections-context";

interface UserTemplatesAndInspectionsListContextWrapperProps {
  children: React.ReactNode;
}

const UserTemplatesAndInspectionsListContextWrapper = ({
  children,
}: UserTemplatesAndInspectionsListContextWrapperProps) => {
  const [userInspectionsList, setUserInspectionsList] =
    useState<UserInspectionsList>({
      userInspectionsListResponse: new ListUserInspectionsResponse({
        inspections: [],
        totalItems: 0,
      }),
      pagination: new Pagination({
        pageSize: 50,
        offset: 0,
      }),
      isLoading: false,
    });
  const userInspectionListContextValue = {
    userInspectionsList,
    setUserInspectionsList,
  };

  const [userTemplatesList, setUserTemplatesList] = useState<UserTemplatesList>(
    {
      userTemplatesListResponse: new ListUserTemplatesResponse({
        templates: [],
        totalItems: 0,
      }),
      pagination: new Pagination({
        pageSize: 50,
        offset: 0,
      }),
      isLoading: false,
    },
  );

  const userTemplateListContextValue = {
    userTemplatesList,
    setUserTemplatesList,
  };

  return (
    <UserInspectionListContext.Provider value={userInspectionListContextValue}>
      <UserTemplateListContext.Provider value={userTemplateListContextValue}>
        {children}
      </UserTemplateListContext.Provider>
    </UserInspectionListContext.Provider>
  );
};

export default UserTemplatesAndInspectionsListContextWrapper;
